export default {
  methods: {
    hasPermission (permission) {
      if (this.$store.state.auth.permissions.PRowner || this.$store.state.auth.permissions.PRadmin) {
        return true
      }

      if(typeof this.$store.state.auth.permissions[permission] !== 'undefined'){
        return this.$store.state.auth.permissions[permission] !== 0
      }

      return false
    },

    hasConfigPermission (permission) {
      if(typeof this.$store.state.auth.config[permission] !== 'undefined'){
        return this.$store.state.auth.config[permission] !== 0
      }

      return false
    },

    hasBackOffice () {
      if(typeof this.$store.state.auth.permissions.PRbackOffice !== 'undefined'){
        return this.$store.state.auth.permissions.PRbackOffice !== 0
      }

      return false
    },

    getLiteSwitch(){
      if (this.$store.state.auth.config.liteSwitch !== 'undefined') {
        return this.$store.state.auth.config.liteSwitch
      }

      return 1
    },

    hasBackOfficeAddons(addOn) {
      return this.$store.state.auth.permissions.BACKOFFICE_ACCOUNT_ADDONS.includes(addOn);
    },

    formatCurrency(value, skipZeroAmount) {
      value = parseFloat(value)
      if(value === 0 && skipZeroAmount) {
        return ''
      }
      if(value < 0) {
        value = -1 * value;
      }
      let val = (value/1).toFixed(2).replace(',', '.')
      return '$'+val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  }
}
